import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';

export const canActivatePlayground = () => {
  if (environment.production) {
    const router = inject(Router);

    return router.navigateByUrl('/home', { replaceUrl: true }).then(() => false);
  }

  return true;
};
